(function () {
    $('.languages input').change(function (e) {
        var target = $(e.target)[0];
        var $parent = $(this).parents('.languages');
        var $label = $parent.find('label[for="' + target.id + '"]');

        $parent.find('button').html($label.text() + ' <span class="caret"></span>');

        $parent.find('form#languages-form').submit();
    });
})();
